import Permisos from '@/router/permisos'

const DefaultContainer = () => import('@/layouts/DefaultLayout.vue')
const ViewRelaCorralCuota = () => import('./Index')

const router = [
  {
    path: '/',
    component: DefaultContainer,
    children: [
      {
        path: 'rela_corral_cuota',
        name: 'Rela corral cuota',
        component: ViewRelaCorralCuota,
        beforeEnter: Permisos.IS_AUTENTICADO,
      },
    ],
  },
]

export default router
